"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFullGroceryListItems = exports.getKrogerItems = void 0;
function getKrogerItems(client) {
    return client.post('get_kroger_items', {});
}
exports.getKrogerItems = getKrogerItems;
function getFullGroceryListItems(client) {
    return client.post('get_full_grocery_list_items', {});
}
exports.getFullGroceryListItems = getFullGroceryListItems;
